import { useState, useCallback } from 'react';
import { EMAIL_REQUIRED, EMAIL_INVALID } from '../constants/errorMessages';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Custom hook for email validation
 * @param {string} initialEmail - Initial email value
 * @returns {Object} Email validation state and handlers
 */
export const useEmailValidation = (initialEmail = '') => {
  const [emailError, setEmailError] = useState('');

  const validateEmail = useCallback((email) => {
    if (email === '') {
      return EMAIL_REQUIRED;
    }
    if (!EMAIL_REGEX.test(email)) {
      return EMAIL_INVALID;
    }
    return '';
  }, []);

  const handleEmailBlur = useCallback(
    (email) => {
      setEmailError(validateEmail(email));
    },
    [validateEmail],
  );

  const handleEmailChange = useCallback(
    (value, currentEmail) => {
      if (emailError) {
        setEmailError(validateEmail(value));
      }
      return value;
    },
    [emailError, validateEmail],
  );

  const isEmailValid = useCallback(
    (email) => {
      return email && !validateEmail(email);
    },
    [validateEmail],
  );

  return {
    emailError,
    setEmailError,
    validateEmail,
    handleEmailBlur,
    handleEmailChange,
    isEmailValid,
  };
};
